module.exports = __webpack_public_path__ + "img/logowebcheckin.c50d235e.svg";